import { Box } from "@mui/material";
import { List, TopToolbar, SelectColumnsButton, useGetList } from "react-admin";

import { SimpleBoxLoader } from "@/components/loader";
import { MODULE_NAMES } from "@/constants/modules";

import { useStatisticsGroups } from "../api";

import {
  ALL_OPTION,
  DEFAULT_DATE_END,
  DEFAULT_DATE_START,
  STATISTICS_REBILLS_BY_CHOICES,
  STATISTICS_TIMEZONES_CHOICES,
  STATISTICS_TYPE_CHOICES,
} from "./constants";
import { StatisticsDatagridWithModal } from "./StatisticsDatagridWithModal";
import { StatisticsFiltersForm } from "./StatisticsFiltersForm";

const ListActions = () => (
  <Box sx={{ width: "100%", display: "flex" }}>
    <StatisticsFiltersForm />
    <TopToolbar sx={{ flexDirection: "column" }}>
      <SelectColumnsButton />
    </TopToolbar>
  </Box>
);

export const StatisticsList = () => {
  const { data: statisticsGroups, isLoading: groupsLoading } =
    useStatisticsGroups();

  const { isLoading: trackersLoading } = useGetList(MODULE_NAMES.TRACKERS);

  const DEFAULT_FILTERS = {
    group: statisticsGroups?.[0],
    type: STATISTICS_TYPE_CHOICES[0].id,
    date_start: DEFAULT_DATE_START,
    date_end: DEFAULT_DATE_END,
    tracker: ALL_OPTION.id,
    timezone: STATISTICS_TIMEZONES_CHOICES[0].id,
    rebills_by: STATISTICS_REBILLS_BY_CHOICES[0].id,
  };

  if (groupsLoading || trackersLoading) {
    return <SimpleBoxLoader />;
  }

  return (
    <List
      filterDefaultValues={DEFAULT_FILTERS}
      actions={<ListActions />}
      pagination={false}
      storeKey={false}
    >
      <StatisticsDatagridWithModal defaultFilters={DEFAULT_FILTERS} />
    </List>
  );
};
